import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de tipos de dieta
 * Maneja todas las operaciones CRUD relacionadas con tipos de dieta
 */
export const tipoDietaApi = {
  /**
   * Obtiene todos los tipos de dieta activos
   * @returns {Promise} - Respuesta de la API
   */
  getAll: () => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get('/tipos-dieta');
  },

  /**
   * Obtiene un tipo de dieta específico por ID
   * @param {number} id - ID del tipo de dieta
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/tipos-dieta/${id}`);
  },

  /**
   * Crea un nuevo tipo de dieta
   * @param {Object} data - Datos del tipo de dieta
   * @param {string} data.nombre - Nombre del tipo de dieta
   * @param {string} data.descripcion - Descripción del tipo de dieta
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.post('/tipos-dieta', data);
  },

  /**
   * Actualiza un tipo de dieta existente
   * @param {number} id - ID del tipo de dieta
   * @param {Object} data - Datos actualizados del tipo de dieta
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.put(`/tipos-dieta/${id}`, data);
  },

  /**
   * Elimina un tipo de dieta (soft delete)
   * @param {number} id - ID del tipo de dieta
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.delete(`/tipos-dieta/${id}`);
  }
};

export default tipoDietaApi;
